import { InputChipData } from "@/shared/components/InputChipString/models/InputChipData";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ACTION_PLAN_CONSTANTS } from "../../constants/ActionPlanConstants";
import { SourceInfoDetails } from "../../models/ActionPlan.model";
import InputChipString from "./../../../../shared/components/InputChipString/InputChipString.vue";
import { InfoInput } from "./../../models/ActionPlan.model";
import CardInputs from "./../CardInputs/CardInputs.vue";

@Component({
  name: "VariableActionPlan",
  components: {
    InputChipString,
    CardInputs
  }
})
export default class VariableActionPlan extends Vue {
  @Prop() sourceInfoDetails!: SourceInfoDetails;
  @Prop() variables!: InfoInput[];

  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  TITLES = ACTION_PLAN_CONSTANTS.TITLES;
  priBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  nameVariable = "";

  formula: InputChipData[] = [];
  isCollapseInput = true;

  get variablesLocal() {
    return this.variables;
  }

  set variablesLocal(e: InfoInput[]) {
    this.$emit("update:variables", [e]);
  }

  get disableAddVariable(): boolean {
    return this.nameVariable == "" || this.formula.length == 0;
  }

  get listInputs() {
    return this.sourceInfoDetails.listInputs.filter(
      form => form.type != "variable"
    );
  }

  addVariable() {
    const index = this.variablesLocal.findIndex(
      x => x.inputName == this.nameVariable
    );

    if (index >= 0) {
      Snackbar.popWarning(ACTION_PLAN_CONSTANTS.MESSAGES.SAME_NAME);
      return;
    }

    const newVariable: InfoInput = {
      inputName: this.nameVariable.trim(),
      formula: this.formula
    };
    this.variablesLocal.push(newVariable);
    this.nameVariable = "";
    this.formula = [];
  }

  removeVar(index: number) {
    this.variablesLocal.splice(index, 1);
  }

  getStringByFormula(formula: InputChipData[]) {
    let text = "";
    formula.forEach(element => {
      if (element.type == "string") {
        text += element.name;
        return;
      }
      text += `[${element.name}~${element.field?.title}]`;
    });
    return text;
  }

  pushField(event: InputChipData) {
    this.isCollapseInput = true;
    this.formula.push(event);
  }
}
